import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../firebase';
import TeacherLessonsTab from './TeacherLessonsTab';
import { signOut } from 'firebase/auth';
import { auth } from '../../firebase';
import { useNavigate } from 'react-router-dom';

const TeacherDashboard = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState('');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        try {
          const userRef = doc(db, 'users', user.uid);
          const userSnap = await getDoc(userRef);
          if (userSnap.exists()) {
            setUserName(userSnap.data().name || 'Teacher');
          } else {
            setUserName('Teacher');
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
          setUserName('Teacher');
        }
      } else {
        setUserName('Teacher');
      }
    });

    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/signin');
  };

  return (
    <div style={styles.container}>
      <div style={styles.header}>
        <h1 style={styles.welcomeText}>Welcome back, {userName}!</h1>
        <div style={styles.headerButtons}>
          <button onClick={() => navigate('/profile')} style={styles.accountButton}>My Account</button>
          <button onClick={handleSignOut} style={styles.signOutButton}>Sign Out</button>
        </div>
      </div>

      <div style={styles.mainContent}>
        <h2 style={styles.sectionTitle}>
          <span role="img" aria-label="blue book">📘</span> Student Lesson Progress
        </h2>
        <TeacherLessonsTab />
      </div>
    </div>
  );
};

export default TeacherDashboard;

const styles = {
  container: {
    padding: '40px 20px',
    maxWidth: '1200px',
    margin: '0 auto',
    backgroundColor: '#f8fafc',
    minHeight: '100vh'
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    marginBottom: '40px',
    borderBottom: '2px solid #e2e8f0',
    paddingBottom: '20px'
  },
  welcomeText: {
    fontSize: '2.2rem',
    fontWeight: '800',
    color: '#1e3a8a',
    fontFamily: "'Merriweather', serif"
  },
  headerButtons: {
    display: 'flex',
    gap: '10px'
  },
  accountButton: {
    padding: '10px 20px',
    backgroundColor: '#17a2b8',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontWeight: 'bold'
  },
  signOutButton: {
    padding: '10px 20px',
    backgroundColor: '#ef4444',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    fontWeight: 'bold',
    cursor: 'pointer'
  },
  mainContent: {
    marginTop: '20px'
  },
  sectionTitle: {
    fontSize: '1.5rem',
    color: '#334155',
    marginBottom: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  }
};